<article class="gw-checkout-container">
  <div class="row">
    <div class="col-left">
      <gw-chkout-home-heading [type]="type">
      </gw-chkout-home-heading>
    </div>
    <div class="col-right">
      <gw-chkout-home-signin [type]="type">
      </gw-chkout-home-signin>
    </div>
  </div>

  <gw-chkout-card [space]="true">
    <gw-chkout-applicant-info type="restrictions"
      title="Check Travel Requirements"
      [citizenship]="restrictionsForm.controls.citizenship"
      [residency]="restrictionsForm.controls.residency"
      [country]="restrictionsForm.controls.country"
      (onInfoUpdated)="onCountryUpdated($event)">
    </gw-chkout-applicant-info>
  </gw-chkout-card>

  @if (restrictions) {
    <section>
      <gw-chkout-card [space]="true"
        title="Summary"
        titleStyle="uppercase"
        [titleBordered]="true"
        class="gw-chkout-restrictions__summary">
        <p>
          <strong>Infection Level: </strong> {{ restrictions.diseaseInfection.level }} <br/>
          <strong>Risk Level: </strong> {{ restrictions.diseaseRiskLevel }} <br/>
        </p>
        <p>
          <strong>Health Department: </strong>
          <a [href]="restrictions.dataSources.healthDepartementSiteLink"
            target="_blank">
            {{ restrictions.dataSources.healthDepartementSiteLink }}
          </a>
        </p>
        <p [innerHtml]="restrictions.summary"></p>
      </gw-chkout-card>
      <gw-chkout-card [space]="true">
        <mat-accordion class="gw-chkout-restrictions__accordion">
          <!-- Entry -->
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <div>Tourist Entry</div>
              <div class="gw-chkout-restrictions__pill"
							[ngClass]="{'gw-chkout-restrictions__pill--red': restrictions.areaAccessRestriction.entry.banned,
							'gw-chkout-restrictions__pill--green':  !restrictions.areaAccessRestriction.entry.banned}">
                {{ restrictions.areaAccessRestriction.entry.banned ? 'Banned' : 'Open'}}
              </div>
            </mat-expansion-panel-header>
            <section>
              <p>
                <strong>Source: </strong>
                <a [href]="restrictions.areaAccessRestriction.entry.rules"
                  target="_blank">
                  {{ restrictions.areaAccessRestriction.entry.rules }}
                </a>
              </p>
              <p [innerHtml]="restrictions.areaAccessRestriction.entry.text"></p>
            </section>
          </mat-expansion-panel>
          <!-- Transportation -->
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <div>Transportation</div>
              <section>
                @switch (restrictions.areaAccessRestriction.transportation.isBanned) {
                  @case ('Yes') {
                    <div
                      class="gw-chkout-restrictions__pill gw-chkout-restrictions__pill--red">
                      Banned
                    </div>
                  }
                  @case ('Partial') {
                    <div
                      class="gw-chkout-restrictions__pill gw-chkout-restrictions__pill--yellow">
                      Limited
                    </div>
                  }
                  @case ('No') {
                    <div
                      class="gw-chkout-restrictions__pill gw-chkout-restrictions__pill--green">
                      Open
                    </div>
                  }
                }
              </section>
            </mat-expansion-panel-header>
            <section>
              <p [innerHtml]="restrictions.areaAccessRestriction.transportation.text"></p>
            </section>
          </mat-expansion-panel>
          <!-- Testing -->
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <div>Testing</div>
              @if (restrictions.areaAccessRestriction.diseaseTesting.isRequired) {
                <div
                  class="gw-chkout-restrictions__pill"
                  [ngClass]="{'gw-chkout-restrictions__pill--red': restrictions.areaAccessRestriction.diseaseTesting.isRequired}">
                  Required
                </div>
              }
            </mat-expansion-panel-header>
            <section>
              <p>
                <strong>Source: </strong>
                <a [href]="restrictions.areaAccessRestriction.diseaseTesting.rules"
                  target="_blank">
                  {{ restrictions.areaAccessRestriction.diseaseTesting.rules }}
                </a>
              </p>
              <p [innerHtml]="restrictions.areaAccessRestriction.diseaseTesting.text"></p>
            </section>
          </mat-expansion-panel>
          <!-- Quarantine -->
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <div>Quarantine</div>
              <section>
                @switch (restrictions.areaAccessRestriction.quarantineModality.eligiblePerson) {
                  @case ('All travellers') {
                    <div
                      class="gw-chkout-restrictions__pill gw-chkout-restrictions__pill--red">
                      All Travelers
                    </div>
                  }
                  @case ('Some travellers') {
                    <div
                      class="gw-chkout-restrictions__pill gw-chkout-restrictions__pill--yellow">
                      Some Travelers
                    </div>
                  }
                  @case ('None') {
                    <div
                      class="gw-chkout-restrictions__pill gw-chkout-restrictions__pill--green">
                      Not Required
                    </div>
                  }
                }
              </section>
            </mat-expansion-panel-header>
            <section>
              <p [innerHtml]="restrictions.areaAccessRestriction.quarantineModality.text"></p>
            </section>
          </mat-expansion-panel>
          <!-- Mask -->
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <div>Mask</div>
              <section>
                @switch (restrictions.areaAccessRestriction.mask.isRequired) {
                  @case ('Yes') {
                    <div
                      class="gw-chkout-restrictions__pill gw-chkout-restrictions__pill--red">
                      Required
                    </div>
                  }
                  @case ('Yes, conditional') {
                    <div
                      class="gw-chkout-restrictions__pill gw-chkout-restrictions__pill--yellow">
                      Conditional
                    </div>
                  }
                  @case ('Recommended') {
                    <div
                      class="gw-chkout-restrictions__pill gw-chkout-restrictions__pill--yellow">
                      Recommended
                    </div>
                  }
                  @case ('Partial') {
                    <div
                      class="gw-chkout-restrictions__pill gw-chkout-restrictions__pill--yellow">
                      Partial
                    </div>
                  }
                  @case ('No') {
                    <div
                      class="gw-chkout-restrictions__pill gw-chkout-restrictions__pill--green">
                      Not Required
                    </div>
                  }
                }
              </section>
            </mat-expansion-panel-header>
            <section>
              <p [innerHtml]="restrictions.areaAccessRestriction.mask.text"></p>
            </section>
          </mat-expansion-panel>
          <!-- Additional Documents -->
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <div>Additional Documents</div>
              <div class="gw-chkout-restrictions__pill"
							[ngClass]="{'gw-chkout-restrictions__pill--red': restrictions.areaAccessRestriction.declarationDocuments.documentRequired == 'Yes',
								'gw-chkout-restrictions__pill--yellow': restrictions.areaAccessRestriction.declarationDocuments.documentRequired != 'Yes'}">
                {{ restrictions.areaAccessRestriction.declarationDocuments.documentRequired == 'Yes' ? 'Required' : 'Not Required' }}
              </div>
            </mat-expansion-panel-header>
            <section>
              @if (restrictions.areaAccessRestriction.declarationDocuments.healthDocumentationLink) {
                <p>
                  <strong>Health Documentation: </strong>
                  <a [href]="restrictions.areaAccessRestriction.declarationDocuments.healthDocumentationLink"
                    target="_blank">
                    {{ restrictions.areaAccessRestriction.declarationDocuments.healthDocumentationLink }}
                  </a>
                </p>
              }
              <p>
                <strong>Travel Documentation: </strong>
                <a [href]="restrictions.areaAccessRestriction.declarationDocuments.travelDocumentationLink"
                  target="_blank">
                  {{ restrictions.areaAccessRestriction.declarationDocuments.travelDocumentationLink }}
                </a>
              </p>
              <p [innerHtml]="restrictions.areaAccessRestriction.declarationDocuments.text"></p>
            </section>
          </mat-expansion-panel>
          <!-- Tracing -->
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <div>Tracing</div>
              <section>
                @switch (restrictions.areaAccessRestriction.tracingApplication.isRequired) {
                  @case ('Yes') {
                    <div
                      class="gw-chkout-restrictions__pill gw-chkout-restrictions__pill--red">
                      Required
                    </div>
                  }
                  @case ('Recommended') {
                    <div
                      class="gw-chkout-restrictions__pill gw-chkout-restrictions__pill--yellow">
                      Recommended
                    </div>
                  }
                  @case ('No') {
                    <div
                      class="gw-chkout-restrictions__pill gw-chkout-restrictions__pill--green">
                      Not Required
                    </div>
                  }
                }
              </section>
            </mat-expansion-panel-header>
            <section>
              <p [innerHtml]="restrictions.areaAccessRestriction.tracingApplication.text"></p>
            </section>
          </mat-expansion-panel>
          <!-- Vaccination -->
          <mat-expansion-panel [hideToggle]="restrictions.areaAccessRestriction.diseaseVaccination.policy == 'No'"
            [disabled]="restrictions.areaAccessRestriction.diseaseVaccination.policy == 'No'">
            <mat-expansion-panel-header>
              <div>Vaccination</div>
              <div class="gw-chkout-restrictions__pill"
							[ngClass]="{'gw-chkout-restrictions__pill--red': restrictions.areaAccessRestriction.diseaseVaccination.isRequired == 'Yes',
								'gw-chkout-restrictions__pill--yellow': restrictions.areaAccessRestriction.diseaseVaccination.isRequired == 'Partial',
								'gw-chkout-restrictions__pill--green': restrictions.areaAccessRestriction.diseaseVaccination.isRequired == 'No'}">
                {{ restrictions.areaAccessRestriction.diseaseVaccination.isRequired == 'Partial' ? 'Partially Required' :
                restrictions.areaAccessRestriction.diseaseVaccination.isRequired == 'Yes' ? 'Required' : 'Not Required' }}
              </div>
            </mat-expansion-panel-header>
            @if (restrictions.areaAccessRestriction.diseaseVaccination.policy == 'Yes') {
              <section>
                <p>
                  <strong>Source: </strong>
                  <a [href]="restrictions.areaAccessRestriction.diseaseVaccination.referenceLink"
                    target="_blank">
                    {{ restrictions.areaAccessRestriction.diseaseVaccination.referenceLink }}
                  </a>
                </p>
                <p>
                  <strong>Qualified Vaccines: </strong>
                  @for (vaccine of restrictions.areaAccessRestriction.diseaseVaccination.qualifiedVaccines; track vaccine; let vaccine_index = $index) {
                    <span>
                      {{ vaccine }}{{ vaccine_index + 1 < restrictions.areaAccessRestriction.diseaseVaccination.qualifiedVaccines.length ? ', ' : ''}}
                    </span>
                  }
                </p>
                <p [innerHtml]="restrictions.areaAccessRestriction.diseaseVaccination.text"></p>
              </section>
            }
          </mat-expansion-panel>
          <!-- Additional Restrictions -->
          @if (restrictions.areaRestrictions) {
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <div>Additional Restrictions</div>
                <div class="gw-chkout-restrictions__pill gw-chkout-restrictions__pill--red">
                  {{ restrictions.areaRestrictions.length }}
                </div>
              </mat-expansion-panel-header>
              <section>
                @for (restriction of restrictions.areaRestrictions; track restriction) {
                  <section>
                    <p><strong>{{ restriction.restrictionType }}</strong></p>
                    <p [innerHtml]="restriction.text"></p>
                  </section>
                }
              </section>
            </mat-expansion-panel>
          }
        </mat-accordion>
      </gw-chkout-card>
      <gw-chkout-card [space]="true">
        <div class="gw-chkout-restrictions__cta">
          <i>Now that you are ready, don’t forget your important documents.</i>
          <section>
            @if (visas_cta) {
              <a
                mat-button href="/travel-visa/{{restrictionsForm.controls.country.value}}">
                Visa Application
              </a>
            }
            <a mat-button href="/step-1">
              Passport Application
            </a>
          </section>
        </div>
      </gw-chkout-card>
    </section>
  }

  @if (loading) {
    <mat-spinner
    class="gw-chkout-restrictions__loader"></mat-spinner>
  }
</article>